<template>
  <div class="map-view">
    <!-- <sticky>
      <tab>
        <tab-item v-for="(item,index) in tabs" @on-item-click="myfunction(item)" :key="index" :selected="tabitem === item">{{item}}</tab-item>
        <tab-item v-for="(item,index) in tabs" @on-item-click="tabitem = item" :key="index" :selected="tabitem === item">{{item}}</tab-item>
      </tab>
    </sticky> -->

    <van-tabs @click="toggleTab" color="#0AA8AF">
      <van-tab title="项目医院"></van-tab>
      <van-tab title="项目药房"></van-tab>
      <van-tab title="公益专员"></van-tab>
    </van-tabs>
    <div v-if="showTip" style="color:red;margin:15px;font-size:14px;">未在本市找到{{tabitem}}，其他本省{{tabitem}}如下：</div>
    <div v-if="showNotice" style="color:red;margin:15px;font-size:14px;">未在本省找到{{tabitem}}</div>

    <div class="tab-content" v-show="tabitem === '项目医院'">
      <div class="info-list">
        <div class="list-item" v-for="hitem in hospitalList" :key="hitem.index">
          <div class="list-title">{{hitem.name}}</div>
          <div class="list-desc">
            <div v-if="hitem.address" class="desc-item">
              <van-icon name="location" />{{hitem.address}}
            </div>
            <div v-if="hitem.doctors && hitem.doctors.length > 0"  class="desc-item">
              <img style="width: 16px;height: 16px;margin:2px 2px 0 0;" src="/static/map/doctor.png" alt="">
              <div>
                <span v-for="hdoctor in hitem.doctors" :key="hdoctor.index" > {{hdoctor.department}}-{{hdoctor.name}} &nbsp;</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    

       <div class="tab-content" v-show="tabitem === '项目药房'">
      <div class="info-list">
        <div class="list-item" v-for="hitem in drugstoreList" :key="hitem.index">
          <div class="list-title">
            <span class="title-tab">{{hitem.province}}</span>
            {{hitem.name}}
          </div>
          <div class="list-desc">
            <div v-if="hitem.druggist_phone" class="desc-item">
              <van-icon name="phone" />{{hitem.druggist_phone}}
            </div>
            <div v-if="hitem.address" class="desc-item">
              <van-icon name="location" />{{hitem.address}}
            </div>
            <div v-if="hitem.handle_time" class="desc-item desc-item-time">
              <van-icon name="clock" />领药时间：{{hitem.handle_time}}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="tab-content" v-show="tabitem === '公益专员'">
      <div class="info-list">
        <div class="list-item" v-for="hitem in volunteerList" :key="hitem.index">
          <div class="list-title">{{hitem.name}}</div>
          <div class="list-desc">
            <div v-if="hitem.has_city" class="desc-item" >
              <van-icon name="location" />{{hitem.has_city}}
            </div>
            <div v-if="hitem.mobile" class="desc-item">
              <!-- <div class="subitem"><i class="iconfont wxicon"></i>指定发药日:{{hitem.handle_time}}</div> -->
              <div class=""><van-icon name="phone" />{{hitem.mobile}}</div>
            </div>
            <div v-if="hitem.avatar" class="desc-item" >
              <img class="img" :src="hitem.avatar" />
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>

</template>

<script>
import {  GetHospital, GetDrugstore,getVolunteers } from "../../api/api";

export default {
  name:'mapview',
    data () {
    return {
      province:'',
      city:'',
      // tabs: [ "项目医院","项目药房"],
      tabitem: "项目医院",
      // citylist: [],
      // value4: [],
      hospitalList:[],
      drugstoreList:[],
      // index: 0,
      volunteerList:[],
      showTip:false,
      showNotice:false,
    }
  },
  created(){
    this.province=this.$route.query.province
    this.city=this.$route.query.city
    this.getData()
  },
  methods: {
    async getData () {
      this.gethospital();
    },
    async gethospital(province, city) {
      await  GetHospital({
        province : this.province,
        city : this.city,
        with_department:1
      }).then((res)=>{
        console.log("GetHospital",res)
        this.hospitalList=[]
        res.data.forEach(ele=>{ 
          this.hospitalList.push(ele)
        })
        if(this.hospitalList.length<=0){//如果本市没有数据,就搜索本省数据
          GetHospital({ province : this.province, with_department:1 }).then((res)=>{
            this.hospitalList=[]
            res.data.forEach(ele=>{ 
              this.hospitalList.push(ele)
            })
            this.checkList(this.hospitalList);
          })
        }
      })
    },
    async getDrugstore(province, city) {
      await GetDrugstore({
          province : this.province,
          city : this.city
      }).then((res)=>{
        this.drugstoreList=[]
        res.data.forEach(ele=>{ 
          this.drugstoreList.push(ele)
        })
        if(this.drugstoreList.length<=0){//如果本市没有数据,就搜索本省数据
          GetDrugstore({ province : this.province }).then((res)=>{
            this.drugstoreList=[]
            res.data.forEach(ele=>{ 
              this.drugstoreList.push(ele)
            })
            this.checkList(this.drugstoreList);
          })
        }
      })
    },
    async getVolunteers(province, city) {
      await getVolunteers({
          province : this.province,
          city : this.city
      }).then((res)=>{
        this.volunteerList=[]
        res.data.forEach(ele=>{ 
          this.volunteerList.push(ele)
        })
        if(this.volunteerList.length<=0){//如果本市没有数据,就搜索本省数据
          getVolunteers({ province : this.province }).then((res)=>{
            this.volunteerList=[]
            res.data.forEach(ele=>{ 
              this.volunteerList.push(ele)
            })
            this.checkList(this.volunteerList);
          })
        }
      })
    },
    checkList(value){
      if(value.length<=0){//如果本省数据也没有
        this.showTip=false;
        this.showNotice=true;
      }else{
        this.showTip=true;
        this.showNotice=false;
      }
    },
    toggleTab(value){
      if(value==0){
        if(this.tabitem=='项目医院') return
        this.tabitem='项目医院'
        this.gethospital();
      }
      if(value==1){
        if(this.tabitem=='项目药房') return
        this.tabitem='项目药房'
        this.getDrugstore();
      }
      if(value==2){
        if(this.tabitem=='公益专员') return
        this.tabitem='公益专员'
        this.getVolunteers();
      }
      this.showTip=false;
      this.showNotice=false;
    }
  },

}
</script>

<style lang='less'>
.map-view{
  // 信息列表（医院、药房等）
  .info-list {
    .list-item {
      position: relative; display: block; background: #fff; margin-top: 10px; padding: 5px 15px; border-top: #e4e4e4 solid 1px; border-bottom: #e4e4e4 solid 1px;
      .list-title {
        border-bottom: #eee solid 1px; font-size: 1.6rem; padding: 5px 0; color: #424242;
        &.no-line { border-width: 0px;}
        span { color: @theme-color; margin-right: 10px;}
        .title-tab{
          padding: 2px 6px;
          margin: 0;
          background-color:#E7FAF7 ;
          color:#0AA8AF ;
          font-size: 12px;
        }
      }
      .list-desc {
        padding: 5px 0 0; font-size: 14px; color: #666;
        .desc-item {
          align-items: center;
          padding: 4px 0; .display-flex;
          i{
            margin: 3px 3px 0 0;
          }
          .img{
            max-width:50vw;
            margin: 3px 3px 0 0;
          }
          .iconfont {
            color: #999; font-size: 20px; vertical-align: -3px; margin-right: 5px;
          }
          .subitem {
            .flex-1;
          }
        }

        .desc-item-time i{
          font-size: 12px;
          margin: 0 5px 0 0;
        }
      }
    }
  }
}
</style>
